import React, { Component } from "react";
import { connect } from "react-redux";
import { setPage } from './redux/actions/page.js';
import styled from "styled-components";

import ArticleBlueBox from "./components/ArticleBlueBox";
import ArticleGray from "./components/ArticleGray";
import ArticleGrayFlip from "./components/ArticleGrayFlip";
import ArticleRedLined from "./components/ArticleRedLined";
import ArticleSub from "./components/ArticleSub";
import ArticleSubFlip from "./components/ArticleSubFlip";
import ArticleWhite from "./components/ArticleWhite";
import ArticleWhiteFlip from "./components/ArticleWhiteFlip";
import BlueMessage from "./components/BlueMessage";
import Border from "./components/Border";
import Calendar from "./components/Calendar";
import Categories from "./components/Categories";
import Contact from "./components/Contact";
import DecoratorImages from "./components/DecoratorImages";
import FormComponent from "./components/FormComponent";
import GrayBoxNoTitle from "./components/GrayBoxNoTitle";
import HappeningNow from "./components/HappeningNow";
import Header from "./components/Header";
import Highlights from "./components/Highlights";
import Loader from "./components/Loader";
import MiniHeader from "./components/MiniHeader";
import Newsletter from "./components/Newsletter";
import SetMapper from "./SetMapper";
import StarFeature from "./components/StarFeature";
import Video from "./components/Video";
import VideoHeader from "./components/VideoHeader";
import Wide from "./components/Wide";
import NotFound from "./components/NotFound";

const Wrapper = styled.div`
  width: 100%;
  float: left;
`;

class Mapper extends Component<Props, State> {
  mapper = (item, index) => {
    if (item.template && item.template.mode) {
      switch (item.template.mode.toLowerCase()) {
        case "articlebluebox":
          return <ArticleBlueBox content={item} key={item.id} />;
        case "articlegray":
          return <ArticleGray content={item} key={item.id} />;
        case "articlegrayflip":
          return <ArticleGrayFlip content={item} key={item.id} />;
        case "articleredlined":
          return <ArticleRedLined content={item} key={item.id} />;
        case "articlesub":
          return <ArticleSub content={item} key={item.id} />;
        case "articlesubflip":
          return <ArticleSubFlip content={item} key={item.id} />;
        case "articlewhite":
          return <ArticleWhite content={item} key={item.id} />;
        case "articlewhiteflip":
          return <ArticleWhiteFlip content={item} key={item.id} />;
        case "bluemessage":
          return <BlueMessage content={item} key={item.id} />;
        case "border":
          return <Border content={item} key={item.id} />;
        case "calendar":
          return <Calendar content={item} key={item.id} />;
        case "categories":
        case "category_list":
          return <Categories content={item} key={item.id} />;
        case "contact":
          return <Contact content={item} key={item.id} />;
        case "decoratorimages":
          return <DecoratorImages content={item} key={item.id} />;
        case "form":
          return <FormComponent content={item} key={item.id} />;
        case "grayboxnotitle":
          return <GrayBoxNoTitle content={item} key={item.id} />;
        case "happeningnow":
          return <HappeningNow content={item} key={item.id} />;
        case "header":
        case "banner":
          return <Header content={item} key={item.id} />;
        case "highlights":
          return <Highlights content={item} key={item.id} />;
        case "loader":
          return <Loader key={index} />;
        case "404":
          return <NotFound key={index} />;
        case "miniheader":
          return <MiniHeader content={item} key={item.id} />;
        case "newsletter":
          return <Newsletter content={item} key={item.id} />;
        case "none":
        case "hide":
        case "hidden":
          return;
        case "set":
          return <SetMapper content={item} key={item.id} />;
        case "starfeature":
          return <StarFeature content={item} key={item.id} />;
        case "video":
          return <Video content={item} key={item.id} />;
        case "videoheader":
          return <VideoHeader content={item} key={item.id} />;
        case "wide":
          return <Wide content={item} key={item.id} />;
        default:
          return item.template.mode;
      }
    }
  };

  componentDidMount () {
    const { page, contentPage } = this.props

    if (!page) return this.props.setPage('home');
    if (!contentPage.length > 0) {
      this.props.setPage(page);
    }
  }

  componentDidUpdate (prevProps) {
    const { page } = this.props

    if (prevProps.page !== page) {
      if (!page) return this.props.setPage('home');
      this.props.setPage(page);
    }
  }

  render() {
    const { contentPage } = this.props

    if (contentPage.length === 0) return null
    return (
      <Wrapper>
        { contentPage && contentPage.map(this.mapper) }
      </Wrapper>
    );
  }
}

const mapStateToProps = ({ contentPage }, { match }) => {
  let page = match.params.page || '';

  return {
    page: page,
    contentPage: contentPage.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setPage: page => {
      dispatch(setPage(page));
    },
    onTodoClick: id => {
      dispatch({ type: "NONE" });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Mapper);



// WEBPACK FOOTER //
// ./src/Mapper.js